import React, { useState } from 'react';
import { Alert, Button, Form, InputNumber, Modal, message } from 'antd';
import { extendPost, fetchPostDetail } from '@/apis/posts';
import usePrivateAction from '@/utils/usePrivateAction';
import { getRequestErrorMessage } from '@/utils/requestError';

const ExtendPost = ({ post, onCancel, onSaved }) => {
  const [error, setError] = useState('');
  const [uncertain, setUncertain] = useState(false);
  const { busy, run } = usePrivateAction();
  const refresh = () => run(async () => {
    const result = await fetchPostDetail(post.id);
    if (String(result?.id) !== String(post.id)) throw new Error('帖子刷新响应无效，请稍后重试');
    return result;
  }, result => onSaved(result), '帖子刷新失败，请稍后重试');
  return <Modal title="延长帖子有效期" open centered footer={null} closable={!busy} keyboard={!busy}
    mask={{ closable: !busy }} onCancel={() => !busy && onCancel()}>
    <p className="dialogForm-note">从原截止时间与当前时间中较晚的一刻起延长。招募开关、名额和已有成员保持不变；重新招募请使用“重新开放招募”。</p>
    <p>当前截止：{post.expire_time ? new Date(post.expire_time).toLocaleString('zh-CN') : '未设置'}</p>
    {error && <Alert type="warning" title={error} action={<Button disabled={busy} onClick={refresh}>刷新帖子</Button>} />}
    <Form name={`extend-post-${post.id}`} aria-label="延长帖子有效期" layout="vertical" initialValues={{ hours: 24 }} disabled={busy || uncertain} onFinish={values => {
      setError('');
      return run(async () => {
        const result = await extendPost(post.id, { hours: values.hours, expected_expire_time: post.expire_time ?? null });
        if (String(result?.id) !== String(post.id) || !Number.isFinite(Date.parse(result.expire_time))
          || !Number.isInteger(result.extended_hours)) throw new Error('延期响应无效，请刷新帖子确认结果');
        return result;
      }, result => {
        message.success(`帖子已延长 ${result.extended_hours} 小时`);
        onSaved({ ...post, ...result });
      }, err => {
        // 提交可能已生效；先重读详情，不自动重放延期请求。
        setUncertain(true);
        const text = getRequestErrorMessage(err, '未能确认延期结果，请先刷新帖子，避免重复延期');
        setError(text);
        return text;
      });
    }}>
      <Form.Item name="hours" label="延长时长（小时）" extra="默认 24 小时，支持 1–720 小时。" rules={[{ required: true, message: '请输入延长时长' }, { type: 'integer', min: 1, max: 720, message: '请输入 1–720 的整数' }]}>
        <InputNumber min={1} max={720} precision={0} style={{ width: '100%' }} />
      </Form.Item>
      <div className="dialogForm-actions"><Button disabled={busy} onClick={onCancel}>取消</Button><Button type="primary" htmlType="submit" disabled={uncertain} loading={busy}>确认延长</Button></div>
    </Form>
  </Modal>;
};

export default ExtendPost;
